export const COUNTERPARTY_COMMENT_MAX_LENGTH = 2048;

export type CounterpartyCommentForm = {
  comment: string;
};

export function createEmptyCommentForm(): CounterpartyCommentForm {
  return {
    comment: '',
  };
}
